var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1028.9 690.5",
    style: {
      enableBackground: "new 0 0 1028.9 690.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F9F9F9;}\n\t.st1{fill:#B7D3F3;}\n\t.st2{fill:#D2E3FC;}\n\t.st3{fill:#C5DCF8;}\n\t.st4{fill:#FFB27D;}\n\t.st5{fill:#1C468A;}\n\t.st6{fill:#163560;}\n\t.st7{fill:#B5453C;}\n\t.st8{fill:#ED975D;}\n\t.st9{fill:#FFFFFF;}\n\t.st10{fill:#ED7D2B;}\n\t.st11{fill:#F99746;}\n\t.st12{fill:#F9DDBF;}\n\t.st13{fill:#ED893E;}\n\t.st14{fill:#95C0F4;}\n\t.st15{fill:#78ACEA;}\n\t.st16{fill:#AEC3FF;}\n\t.st17{fill:#A02E2E;}\n\t.st18{fill:#BC3F3F;}\n\t.st19{fill:#9DB0F4;}\n\t.st20{fill:#233862;}\n\t.st21{fill:#008080;}\n\t.st22{fill:#025654;}\n\t.st23{fill:#E2915A;}\n\t.st24{fill:#2A4E96;}\n\t.st25{fill:#DCEAFF;}\n\t.st26{fill:#025B59;}\n\t.st27{fill:#ED985F;}\n\t.st28{fill:#2C3A64;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M893.8,273.1l-316,282.8L411.7,404.1L283.3,524.4l-80.8,76.3H50.7c42.2-37.7,211-196.6,325-304.4l34.1-32.3 l168.8,153.5l246.9-221.8L893.8,273.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M785.1,161.7L936,323.3l42.2-184.9L785.1,161.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.3,502c-0.9-14.4-1.8-27.8-3.6-36.8l-3.6-22.4c-0.9-0.9-5.4-6.3-15.3-6.3s-9,7.2-9,7.2l0.9,0.9 c0,0,9,35,8.1,79.9v2.7h22.4V502z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M294,524.4l-0.9,0.9v-1.8h-19.8l-0.9,1.8l-0.9-1.8c0.2-26.9-2.8-53.7-9-79.9c0,0-0.9-7.2,9-7.2 c9.9,0,14.4,5.4,14.4,6.3l2.7,13.5c3.3,15,5.1,30.4,5.4,45.8V524.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M270.7,525.3H347c0,0-1.8-8.1-45.8-7.2C269.8,519.1,270.7,525.3,270.7,525.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.4,605.2c9-47.6,6.3-77.2,6.3-77.2l1.8-1.8l4.5,0.9c0.9,0.9,2.7,36.8-10.8,78.1H264.4z M335.3,605.2 c-9-47.6-6.3-77.2-6.3-77.2l-1.8-1.8l-4.5,0.9c0,0.9-1.8,36.8,10.8,78.1H335.3z M349.7,605.2c-9-47.6-6.3-77.2-6.3-77.2l-2.7-1.8 l-3.6,0.9c-0.9,0.9-2.7,36.8,10.8,78.1H349.7z M278.8,605.2c8.1-47.6,6.3-77.2,6.3-77.2l1.8-1.8l4.5,0.9c0,0.9,1.8,36.8-10.8,78.1 H278.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347,523.6h-76.3c-0.9,0-1.8,0-1.8,1.8v0.9l1.8,1.8H347l1.8-1.8v-0.9C348.8,523.6,347.9,523.6,347,523.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M344.3,454.4l25.1-6.3l1.8,3.6c0,0-27.8,18-30.5,17.1S344.3,454.4,344.3,454.4z M321,576.5v2.7 c0,1.8,2.7,3.6,4.5,5.4l0.9,0.9l5.4,7.2c4.5,4.5,7.2,4.5,8.1,4.5c0.9-0.9-0.9-3.6-2.7-6.3l-0.9-1.8c-1.8-2.7-0.9-4.5-0.9-9.9 c0-3.6,6.3-22.4,6.3-22.4l-8.1-1.8c0,0-2.7,14.4-5.4,17.1l-4.5,1.8v0.9L321,576.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M321,576.5v2.7l4.5,5.4l0.9,0.9l5.4,7.2c4.5,4.5,7.2,4.5,8.1,4.5c0.9-0.9-0.9-3.6-2.7-6.3 c-2.7-0.9-5.4-3.6-7.2-6.3l-6.3-9.9L321,576.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M387.4,571.1c0,2.7,3.6,2.7,8.1,0.9c4.5-1.8,2.7,0,8.1,0c6.3-0.9,8.1-3.6,8.1-4.5l-5.4-0.9h-1.8 c-3.6-0.9-5.4-2.7-9-5.4c-2.7-1.8-7.2-9-7.2-9l-8.1,0.9l6.3,9l0.9,6.3V571.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M395.5,572h8.1c6.3-0.9,8.1-3.6,8.1-4.5l-5.4-0.9c-2.7,1.8-5.4,2.7-9,2.7l-10.8-0.9l0.9,2.7 C387.4,573.8,391,573.8,395.5,572z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M369.5,448.1c0,0,1.8-5.4,4.5-5.4h9c0,0.9,0,4.5-1.8,5.4c-1.8,1.8-9.9,3.6-9.9,3.6L369.5,448.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M356.9,517.3l-17.1,48.5h-5.4l-4.5-2.7c0,0,4.5-46.7,11.7-56.6C349.7,496.6,356.9,517.3,356.9,517.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M290.5,497.5c0,0,48.5-17.1,59.3-13.5c10.8,3.6,43.1,72.7,43.1,72.7l-2.7,1.8l-6.3,0.9c0,0-29.6-26.9-33.2-35 c-3.6-7.2-4.5-15.3-8.1-14.4s-44.9,18-54.8,8.1c-9-10.8-6.3-24.2-6.3-24.2L290.5,497.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M318.3,374.5c-2.7-1.8-5.4-1.8-7.2-1.8l1.8-0.9l-3.6,1.8c-15.3-6.3-17.1,17.1-17.1,22.4c0,6.3,0,12.6-7.2,17.1 c-15.3,9.9-2.7,26.9-2.7,26.9l7.2,12.6c-0.9-4.5,18.9-27.8,28.7-35c2.7-4.5,3.6-10.8,3.6-11.7c0,5.4-0.9,9-1.8,9.9 C328.2,407.7,323.7,377.2,318.3,374.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M318.3,417.6c0,0-5.4,2.7-9,1.8s-5.4-5.4-5.4-5.4c0.9-0.9,1.8-2.7,1.8-12.6l0.9,0.9l10.8,1.8v7.2L318.3,417.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M317.4,404.1v7.2c-6.3,0-9.9-6.3-11.7-9.9L317.4,404.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M304.8,400.6c0,0-3.6-5.4-3.6-9.9c-0.9-3.6,0.9-16.2,12.6-14.4c2.7,0,4.5,0.9,6.3,2.7 c2.7,1.8,6.3,5.4,2.7,16.2l-0.9,3.6L304.8,400.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M319.2,407.7c0,0-14.4,0-14.4-9.9s-1.8-16.2,7.2-17.1c9.9-0.9,11.7,3.6,11.7,6.3 C324.6,390.7,323.7,407.7,319.2,407.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M319.2,380.8c0,0-4.5,11.7-10.8,13.5c-6.3,1.8-9,0-9,0c3.6-3.6,5.4-7.2,6.3-11.7 C305.7,382.6,315.6,375.4,319.2,380.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M318.3,381.7l3.6,5.4c0.9,1.8,0.9,7.2,2.7,7.2c0,0,2.7-8.1-0.9-12.6S318.3,381.7,318.3,381.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M285.1,460.7c-1.8-7.2,3.6-19.8,9-30.5c4.5-9,9-17.1,9.9-16.2c11.7,7.2,13.5,0.9,13.5,0.9s10.8,1.8,14.4,7.2 c3.6,7.2,8.1,27.8,12.6,32.3v5.4l0.9,1.8l1.8,4.5c-1.8,1.8-6.3,4.5-9,2.7c-5.4-3.6-9-12.6-10.8-16.2c-4.5,27.8,1.8,33.2-1.8,36.8 c-2.7,2.7-7.2-1.8-18,2.7c-6.3,3.6-16.2,8.1-22.4,9c-2.7,0-5.4,0-6.3-2.7C276.1,491.2,287.8,473.3,285.1,460.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M316.5,401.5c0,0,0,1.8,2.7,0.9l2.7-0.9H316.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M278.8,498.4c0.9,1.8,3.6,2.7,6.3,2.7c4.5-2.7,23.3-9.9,23.3-15.3c0-8.1-3.6-8.1-1.8-18 c2.7-7.2-15.3-21.5-18-25.1c-5.4,10.8-5.4,10.8-3.6,18C287.8,473.3,276.1,491.2,278.8,498.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M277,469.7c2.7-4.5,6.3-7.2,9-9c-0.9-0.9,13.5-19.8,13.5-23.3l4.5-24.2c0,0-12.6,0.9-16.2,7.2 C282.4,428.4,271.6,458.9,277,469.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M286,460.7l24.2,7.2l-2.7,4.5c0,0-29.6-0.9-30.5-2.7C275.2,467.9,286,460.7,286,460.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M327.3,452.6c1.8,3.6,5.4,12.6,10.8,16.2c2.7,1.8,7.2-0.9,9-2.7l-1.8-4.5l-5.4,1.8 C337.1,463.4,327.3,452.6,327.3,452.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M310.2,467.9c0,0,7.2-2.7,9-1.8c1.8,0,8.1,4.5,7.2,6.3c-0.9,0.9-6.3-0.9-9-0.9l-6.3,1.8l-3.6-0.9L310.2,467.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M310.2,467.9l4.5-3.6v2.7C312.9,468.8,310.2,467.9,310.2,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M345.2,479.6h-35.9l0.9-2.7l1.8-0.9h33.2V479.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M345.2,438.3H400l-13.5,41.3h-54.8L345.2,438.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M400.9,438.3l-13.5,41.3h-55.7l14.4-41.3H400.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M371.3,458l-1.8,1.8l-1.8,0.9c-1.8,0-2.7-0.9-1.8-2.7l0.9-1.8l1.8-0.9C370.4,455.3,371.3,457.1,371.3,458z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M400.9,438.3l-13.5,41.3h-36.8c24.2-9,30.5-35.9,32.3-41.3H400.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M242,605.2h0.9v-0.9l7.2-42.2l9.9-59.3l2.7-17.1h-7.2l-0.9,9.9l-9,68.2l-5.4,40.4l0.9,0.9H242z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M254.5,495.7c4.5,1.8,5.4,7.2,5.4,7.2l2.7-17.1h-7.2L254.5,495.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M417,605.2h-0.9l-0.9-0.9l-7.2-42.2l-9.9-59.3l-2.7-17.1h7.2l0.9,9.9l9,68.2l5.4,40.4v0.9H417z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M404.5,495.7c-5.4,1.8-6.3,7.2-6.3,7.2l-2.7-17.1h7.2L404.5,495.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M236.6,492.1H417c2.7,0,4.5-1.8,4.5-4.5V484c0-2.7-1.8-4.5-4.5-4.5H236.6c-1.8,0-3.6,1.8-3.6,4.5v3.6 C233,490.3,234.8,492.1,236.6,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M684.6,472.4c0,0-4.5,6.3-2.7,7.2c0.9,0.9,5.4,1.8,6.3,0.9l0.9-8.1H684.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M684.6,472.4l-2.7,1.8l-1.8,3.6l2.7-1.8L684.6,472.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M702.5,389.8l-6.3,53.9l-0.9,4.5l-2.7,12.6l-3.6,13.5l-4.5-1.8l0.9-31.4c0.9-5.4,5.4-41.3,7.2-46.7 C694.5,389.8,702.5,389.8,702.5,389.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M691.8,515.5l-28.7-8.1l-4.5-3.6l-0.9-6.3l3.6-12.6c0-1.8,1.8-3.6,2.7-4.5c1.8-1.8,3.6-1.8,5.4-0.9l28.7,8.1 c1.8,0,3.6,1.8,4.5,3.6l0.9,5.4l-3.6,13.5c0,1.8-1.8,3.6-2.7,4.5L691.8,515.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M664.8,485.8l-3.6,13.5v3.6c0.6,2.7,2.7,4.8,5.4,5.4l28.7,8.1c1.8,0.9,3.6,0,5.4-0.9s2.7-2.7,2.7-4.5 l3.6-13.5c0.9-1.8,0-3.6-0.9-5.4l-3.6-3.6l-9.9-2.7v-4.5l-1.8-1.8H690l-5.4-1.8H681l-0.9,1.8l-0.9,2.7l-6.3-1.8h-3.6l-2.7,1.8 L664.8,485.8z M690.9,484.9l-10.8-2.7l0.9-2.7l0.9-0.9l2.7,0.9l5.4,1.8h0.9l0.9,0.9L690.9,484.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M687.3,480.5c0,0,1.8-1.8,0.9-2.7l-1.8,2.7v-3.6l-1.8,2.7l0.9-2.7l-1.8,1.8v-1.8l-1.8,1.8L687.3,480.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M695.4,448.1l-2.7,12.6l-2.7-9.9c-0.9-9,2.7-27.8,2.7-27.8L695.4,448.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M755.5,469.7l6.3,6.3l1.8,8.1c0,1.8-3.6-3.6-4.5-4.5c-1.8,0,0.9,2.7,0.9,2.7c-0.9,0.9-2.7-0.9-3.6-1.8 l-3.6-6.3C751.9,471.5,755.5,469.7,755.5,469.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M689.1,602.6h25.1c1.8-0.9,0-14.4,0-14.4s-7.2-2.7-8.1,3.6c-1.8,5.4-9,7.2-13.5,8.1 C690,599.9,689.1,601.7,689.1,602.6z M726.8,602.6h25.1c1.8-0.9,0-14.4,0-14.4s-7.2-2.7-9,3.6c-0.9,5.4-8.1,7.2-12.6,8.1 C727.7,599.9,726.8,601.7,726.8,602.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M696.3,470.6l1.8,34.1l7.2,86.2c0.9,18.9,2.7,3.6,9.9,1.8c0.9,0,6.3-21.5,8.1-45.8V546l4.5-77.2L696.3,470.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M695.4,466.1l2.7,38.6l25.1,42.2V546l4.5-77.2L695.4,466.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M702.5,466.1l24.2,66.4c4.5,12.6,16.2,58.4,16.2,58.4s4.5,1.8,9-0.9c0,0,4.5-47.6-4.5-60.2 c-4.5-7.2-0.9-72.7-19.8-73.6C708.8,456.2,702.5,466.1,702.5,466.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M737.6,469.7c-8.1,4.5-40.4,4.5-41.3,0.9c-3.6-8.1-4.5-48.5-2.7-61.1c0,0,0.9-18.9,2.7-18 c11.7-6.3,30.5-0.9,30.5-0.9c5.4,1.8,5.4,14.4,6.3,32.3l0.9,7.2C734.6,443.4,735.8,456.6,737.6,469.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M718.7,388.9c-0.9,3.6-4.5,2.7-9.9,1.8c-5.4-1.8-3.6-4.5-3.6-4.5l0.9-5.4v-3.6l0.9-1.8c0-2.7,9.9,0,9.9,0.9 L718.7,388.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M707.9,395.2l-0.9-5.4l5.4,0.9l-1.8,4.5H707.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M706.1,384.4l-3.6,5.4l0.9,2.7l1.8,2.7l4.5-4.5C709.7,390.7,707,389.8,706.1,384.4z M709.7,390.7l2.7,5.4 c0,0,7.2-2.7,9-6.3l-3.6-5.4C717.8,384.4,717.8,388.9,709.7,390.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M716.9,378.1c-3.6,2.7-7.2,3.6-10.8,2.7v-3.6h2.7L716.9,378.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M719.6,374.5c-1.8,6.3-9.9,5.4-13.5,3.6h-1.8l-0.9-5.4l2.7-13.5c1.8-2.7,4.5-5.4,12.6-1.8 C725.9,361,722.3,366.4,719.6,374.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M725.9,370.9l-8.1,6.3l1.8-2.7v-5.4h-1.8l-0.9,0.9l-0.9-0.9c-2.7-0.9,0-3.6-1.8-5.4c-1.8-2.7-9-2.7-9-3.6 c-2.7-1.8-0.9-7.2-0.9-8.1c2.7,0.9,5.4,0,8.1-0.9c3.6-0.9,8.1,1.8,9,2.7V353l0.9,0.9v0.9h0.9C727.7,359.3,727.7,370,725.9,370.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M707.9,373.6h-2.7c0,0-1.8,0-0.9-0.9C704.3,372.7,706.1,371.8,707.9,373.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M707.9,395.2l-4.5,64.6c0,4.5,4.5,9.9,4.5,9.9s3.6-4.5,4.5-9c0.9-4.5-1.8-65.5-1.8-65.5H707.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M727.7,390.7c0,0,7.2,1.8,12.6,13.5c5.4,11.7,9.9,35,12.6,41.3c2.7,6.3,4.5,26,4.5,26l-4.5,1.8 c0,0-9.9-19.8-11.7-26l-13.5-32.3V390.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M737.6,469.7c-13.5-1.8-9.9-49.4-9-49.4c0.9-0.9,5.4,8.1,5.4,8.1v1.8C734.6,443.4,735.8,456.6,737.6,469.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M905.4,574.7c0,0,6.3,5.4,4.5,9c-0.9,4.5-6.3,6.3-6.3,11.7c-0.9,4.5-3.6,7.2-6.3,7.2h-11.7 c0,0-1.8-3.6,2.7-4.5c4.5-0.9,6.3-6.3,5.4-11.7l0.9-12.6l9-1.8L905.4,574.7z M837.2,589.1c0,0,0.9,11.7-1.8,13.5H804 c0,0,0-4.5,4.5-5.4c5.4,0,14.4-3.6,16.2-10.8C825.5,579.2,837.2,589.1,837.2,589.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M810.3,412.2c3.6,58.1,7.8,116.2,12.6,174.2c0,0,5.4,5.4,15.3,2.7c0,0,9.9-33.2,12.6-68.2v-1.8l6.3-109.5 L810.3,412.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M810.3,412.2l3.6,48.5l35.9,60.2l0.9-1.8l6.3-109.5L810.3,412.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M817.5,414.9c21.9,56.3,47.4,111.2,76.3,164.3c0,0,10.8-4.5,11.7-8.1c0,0-7.2-71.8-20.6-89.8 c-7.2-9.9-13.5-31.4-13.5-42.2c0.9-18-5.4-38.6-5.4-38.6L817.5,414.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M794.1,415.8c0,0-6.3,8.1-6.3,10.8v11.7c0.9,1.8,3.6-6.3,5.4-7.2l-0.9,3.6c0.9,0.9,3.6-2.7,4.5-3.6l1.8-10.8 C800.4,416.7,794.1,415.8,794.1,415.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M818.4,298.2l-8.1,77.2l-1.8,6.3l-4.5,18.9l-4.5,18.9l-4.5,0.9l-0.9-0.9l-1.8-0.9c0,0,0-37.7,1.8-45.8 c1.8-8.1,7.2-60.2,9.9-67.3C806.7,298.2,818.4,298.2,818.4,298.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M808.5,381.7l-4.5,18.9l-2.7-14.4c-1.8-12.6,2.7-39.5,2.7-39.5L808.5,381.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M868.6,414c-10.8,6.3-57.5,6.3-59.3,0.9c-5.4-10.8-6.3-70-4.5-88c0,0.9,1.8-26.9,4.5-26 c17.1-8.1,44.9-0.9,44.9-0.9c7.2,2.7,6.3,20.6,9,46.7l0.9,10.8c1.8,15.3,3.6,34.1,7.2,53C871.3,412.2,870.4,413.1,868.6,414z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M841.7,297.3c-0.9,4.5-6.3,4.5-14.4,2.7c-7.2-1.8-4.5-6.3-4.5-6.3l0.9-8.1l0.9-4.5v-2.7 c0.9-4.5,14.4,0,14.4,0.9L841.7,297.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M825.5,305.4v-6.3l8.1,1.8l-3.6,5.4L825.5,305.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M823.7,290.1l-5.4,8.1l1.8,4.5c0,1.8,1.8,2.7,2.7,3.6l6.3-6.3C829.1,300,824.6,298.2,823.7,290.1z M829.1,300 l4.5,7.2c0,0,9.9-2.7,12.6-8.1l-5.4-8.1C840.8,291.9,839.9,297.3,829.1,300z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M839,282c-4.5,2.7-9.9,4.5-15.3,3.6l0.9-4.5l2.7-0.9L839,282z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M843.5,276.7c-3.6,9.9-15.3,7.2-19.8,5.4H821l-1.8-7.2c0.9-7.2,2.7-18,4.5-19.8c2.7-3.6,6.3-7.2,17.1-2.7 C852.5,257.8,847.1,265,843.5,276.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M851.6,272.2l-10.8,9l1.8-4.5v-0.9l1.8-4.5v-2.7c-1.8-0.9-2.7,0-4.5,0.9l-0.9,0.9l-0.9-0.9 c-3.6-1.8,0-5.4-2.7-8.1c-1.8-3.6-12.6-3.6-12.6-5.4c-3.6-2.7-0.9-10.8-0.9-10.8c3.6,0,8.1,0,11.7-1.8c5.4-0.9,10.8,2.7,13.5,3.6 l-0.9-0.9l0.9,1.8l1.8,0.9H848C855.2,254.2,855.2,269.5,851.6,272.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M826.4,275.8h-3.6L821,274C821,274,823.7,273.1,826.4,275.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M825.5,305.4l-6.3,93.4c0,8.1,7.2,15.3,7.2,15.3s5.4-6.3,7.2-13.5c0.9-7.2-3.6-94.3-3.6-94.3L825.5,305.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M868.6,414c-19.8-2.7-13.5-71.8-12.6-71.8c1.8,0,7.2,12.6,7.2,12.6l0.9,2.7c0.9,15.3,3.6,34.1,6.3,53 C871.3,412.2,870.4,413.1,868.6,414z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M926.1,465.2l-41.3,12.6c-2.7,0.9-5.4,0.9-8.1-0.9c-1.8-0.9-3.6-3.6-4.5-6.3l-5.4-18.9c-0.9-2.7,0-6.3,0.9-9 c0.9-1.8,3.6-3.6,6.3-4.5l40.4-13.5c2.7,0,5.4,0,8.1,1.8c2.7,0.9,3.6,3.6,4.5,6.3l5.4,18.9c0.9,2.7,0.9,5.4-0.9,8.1 C930.6,462.5,927.9,464.3,926.1,465.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M872.2,449.9l5.4,18.9l2.7,4.5c0.9,1.8,2.7,2.7,4.5,2.7l3.6,0.9l1.8-0.9l41.3-12.6c1.8-0.9,4.5-2.7,5.4-5.4 c1.8-1.8,1.8-5.4,0.9-8.1l-5.4-18.9c0-2.7-1.8-5.4-4.5-6.3c-1.8-1.8-5.4-1.8-7.2-0.9l-14.4,3.6l-0.9-3.6l-1.8-2.7H901l-1.8,0.9 l-8.1,2.7h-2.7l-1.8,1.8v2.7l0.9,4.5l-8.1,2.7h-0.9c-3.1,1.3-5.4,3.9-6.3,7.2V449.9z M904.5,428.4l-15.3,4.5l-0.9-3.6v-0.9l0.9-0.9 l3.6-0.9l6.3-2.7h3.6v0.9L904.5,428.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M892,416.7c0,0-1.8,10.8,0.9,10.8c2.7,0,8.1-0.9,9-3.6l-4.5-10.8L892,416.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M892,416.7l-1.8,3.6v6.3l1.8-4.5V416.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M854.3,300c0,0,9.9,2.7,18,19.8s14.4,50.3,18.9,59.3c3.6,9,6.3,35.9,6.3,35.9l-1.8,1.8H892 c0,0-15.3-26-18-35.9L855.2,335L854.3,300z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M175.5,591.8l-0.9-11.7l6.3-6.3l1.8,16.2L175.5,591.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M197.1,602.6h-26c0,0-0.9-4.5,0.9-8.1c0.9-2.7,3.6-4.5,3.6-7.2c1.8,1.8,3.6,2.7,7.2,2.7l4.5,6.3 C189,597.2,197.1,597.2,197.1,602.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M191.7,431.1l-3.6,42.2c-6.3,69.1-5.4,112.2-5.4,112.2s0,0.9-4.5,0.9l-3.6-0.9c0,0-14.4-44.9-13.5-70.9 l1.8-8.1c2.7-13.5-12.6-63.7,4.5-82.6S192.6,423.9,191.7,431.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M191.7,431.1l-3.6,42.2l-26.9,41.3l1.8-8.1c2.7-13.5-12.6-63.7,4.5-82.6S192.6,423.9,191.7,431.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M213.2,289.2l-1.8-6.3c0-0.9,1.8-9,3.6-9.9c1.8,0,5.4,4.5,4.5,9l-1.8,8.1L213.2,289.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M213.2,289.2l-1.8-2.7l-2.7-4.5h1.8l1.8,2.7L213.2,289.2z M103.7,300.9l-0.9,0.9c0-0.9-3.6-8.1-5.4-8.1 c-1.8-0.9-4.5,5.4-2.7,9l4.5,8.1l4.5-2.7l0.9-2.7V300L103.7,300.9z M131.5,588.2l-0.9-14.4c0,0,9.9-2.7,9.9-0.9l-1.8,17.1l-3.6,1.8 L131.5,588.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M184.5,430.2c0,0-37.7,108.6-44.9,155.3l-4.5,0.9c-3.6-0.9-4.5-3.6-4.5-3.6s-7.2-55.7,6.3-75.4 c9-13.5-3.6-72.7,17.1-77.2C175.5,425.7,184.5,430.2,184.5,430.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M177.3,326l-0.9-2.7c-1.1-4-2.6-7.9-4.5-11.7v-0.9c-0.9-2.7-2.7-4.5-4.5-4.5h-6.3l0.9-1.8l-3.6,1.8 c-17.1-3.6-16.2,21.5-14.4,27.8c0.9,5.4-4.5,8.1-12.6,14.4c-14.4,11.7-14.4,23.3-14.4,23.3h0.9l2.7-4.5l-0.9,6.3 c7.5,4.4,14.7,9.1,21.5,14.4v-3.6l1.8,4.5v0.9l5.4,3.6l0.9,0.9c-0.9-1.8,0.9-5.4,3.6-10.8l0.9-0.9c0-1.8,0.9-2.7,2.7-4.5l0.9-1.8 l0.9-1.8l1.8-3.6c4.4-6.6,9.2-12.9,14.4-18.9l0.9-0.9l0.9-2.7v-1.8l0.9-7.2v8.1l-0.9,0.9v1.8l0.9-1.8l0.9-0.9 C180,342.2,179.1,334.1,177.3,326z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M174.6,352.1c0,0-5.4,3.6-9,3.6c-4.5-0.9-7.2-5.4-7.2-5.4c1.8-0.9,1.8-2.7,0-12.6h13.5l0.9,8.1 C172.8,349.4,173.7,352.1,174.6,352.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M171.9,337.7l0.9,8.1c-7.2,0.9-11.7-5.4-13.5-8.1H171.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M158.5,335.9l-6.3-9.9c-0.9-3.6-0.9-17.1,11.7-17.1c2.7,0,5.4,0,7.2,1.8c3.6,0.9,8.1,4.5,5.4,17.1l-0.9,4.5 L158.5,335.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M193.5,428.4c0,0-16.2,9.9-35.9,4.5l-16.2-2.7l2.7-15.3c3.6-9,9.9-62.8,15.3-65.5c1.8,1.8,5.4,2.7,9,2.7 c3.6,0,5.4-1.8,4.5-3.6l8.1,3.6C184.5,358.4,193.5,428.4,193.5,428.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M174.6,341.3c0,0-16.2,2.7-17.1-8.1c-1.8-9.9-4.5-17.1,5.4-18.9c9.9-2.7,12.6,0.9,13.5,4.5 C178.2,322.4,178.2,340.4,174.6,341.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M170.1,312.6c0,0-2.7,13.5-9,16.2c-6.3,2.7-9.9,1.8-9.9,1.8c2.7-3.6,4.5-8.1,4.5-13.5 C155.8,317.1,165.7,307.2,170.1,312.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M169.2,314.4c0,0,3.6,1.8,4.5,4.5c0.9,2.7,2.7,8.1,3.6,7.2c0,0,2.7-9-1.8-12.6 C171,309,169.2,314.4,169.2,314.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M217.7,289.2l-2.7-0.9h-2.7l-4.5,31.4c0,1.8-18.9,24.2-24.2,24.2c-4.5,0-9.9,3.6-10.8,4.5 c0,0,10.8,23.3,10.8,27.8l6.3,80.8c0,0,0,3.6,6.3,0.9l7.2-2.7l-7.2-78.1l-0.9-7.2v-2.7l1.8-2.7c7.2-11.7,19.8-29.6,20.6-34.1V289.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M154,602.6h-26.9c0,0-0.9-4.5,0.9-8.1c0.9-2.7,3.6-4.5,3.6-7.2c1.8,1.8,3.6,2.7,7.2,2.7l4.5,6.3 C145,597.2,153.1,597.2,154,602.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M171.9,379c-0.9-6.3-12.6-29.6-12.6-29.6s-7.2-2.7-11.7,0c-5.4,1.8-29.6-13.5-30.5-14.4l-13.5-27.8H101 l-1.8,1.8v1.8l12.6,37.7c1.8,2.7,15.3,13.5,26,21.5l1.8,2.7l0.9,4.5l-3.6,36.8l-1.8,46.7c0,0,11.7,4.5,19.8,5.4c8.1,0,9.9-9,9.9-9 S172.8,385.3,171.9,379z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M169.2,335.9l4.5,0.9l1.8-1.8h-2.7L169.2,335.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M670.2,136.6c0,0-7.2-14.4,0-17.1c8.1-2.7,10.8,0,11.7,2.7l-2.7,16.2L670.2,136.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M676.5,225.5c-23.7,4.4-47.9,5-71.8,1.8c-21.5-3.6-33.2-9.9-33.2-9.9s19.8-44,35.9-42.2 c18.9,1.8,50.3,19.8,53.9,14.4c3.6-5.4,6.3-53.9,6.3-53.9c8.1-6.3,13.5,0,13.5,0S697.2,221.9,676.5,225.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M676.5,225.5c-21.3,3.9-43.1,4.8-64.6,2.7c-5.4-17.1-9-34.1,0.9-24.2C630.7,222.8,676.5,225.5,676.5,225.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M569.7,583.7c0,0-0.9,18,2.7,19.8h44c0,0,0-5.4-7.2-7.2c-7.2-0.9-19.8-5.4-21.5-15.3 C584.9,571.1,569.7,583.7,569.7,583.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M602.9,370l-1.8,34.1c-5.4,51.2-7.2,112.2-7.2,123.9l-5.4,53.9c0,0-7.2,7.2-22.4,3.6c0,0-11.7-47.6-14.4-97 v-2.7l-0.9-21.5l-5.4-135.6l56.6-13.5L602.9,370z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M602.9,370l-52.1,94.3l-5.4-135.6l56.6-13.5L602.9,370z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M461,319.8l-9.9,14.4c-0.9,3.6-2.7,14.4-1.8,18s7.2-9,9-10.8c2.7-0.9-1.8,5.4-0.9,6.3s5.4-3.6,7.2-5.4 c1.8-1.8,0.9-10.8,3.6-16.2C470,320.6,461,319.8,461,319.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M458.3,564c0,0-7.2,7.2-6.3,13.5c1.8,5.4,9,9,9.9,15.3c0.9,7.2,4.5,10.8,8.1,10.8h17.1c0,0,2.7-4.5-3.6-6.3 c-6.3-1.8-9-9-8.1-17.1l-0.9-17.1l-13.5-2.7L458.3,564z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M593,330.5c0,0-52.1,119.4-79.9,172.4l-36.8,67.3c0,0-16.2-7.2-17.1-11.7c0,0,9.9-101.5,28.7-126.6 c10.8-13.5,23.3-55.7,23.3-70c0.9-15.3,13.5-50.3,13.5-50.3L593,330.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M608.3,335.9c0,0-20.6,15.3-50.3,13.5c-12.6,0-38.6-4.5-43.1-15.3c-0.9-2.7,0-6.3,1.8-10.8 c3.6-13.5,12.6-37.7,9.9-93.4v-14.4c2.7-26.9,17.1-43.1,31.4-48.5c35-13.5,45.8,4.5,45.8,4.5s15.3,13.5,18,40.4 C626.2,265,608.3,335.9,608.3,335.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M567.9,163.5c0,0,16.2,9.9,33.2,7.2c0,0,3.6-0.9,1.8-4.5l1.8-6.3l1.8-9l-9.9-10.8l-9-10.8 C584.9,154.6,567.9,163.5,567.9,163.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M585.8,139.3c0,0,5.4,15.3,18.9,20.6l1.8-11.7l-9.9-8.1L585.8,139.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M617.2,150.1c0,0-30.5,4.5-32.3-15.3s-7.2-32.3,11.7-35.9c18.9-3.6,24.2,3.6,26,9.9 C624.4,115.1,625.3,149.2,617.2,150.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M575.9,95.3l-2.7-0.9l2.7-0.9c0-1.8,1.8-5.4,4.5-6.3l-0.9,1.8l-0.9,1.8c3.6-4.5,12.6-7.2,35-4.5 c30.5,4.5,19.8,24.2,15.3,26.9c-3.6,1.8-13.5-5.4-20.6-4.5c-7.2,0-9,11.7-11.7,12.6c-2.7,1.8-0.9-0.9-4.5-2.7s-3.6,3.6-2.7,8.1 c0.9,3.6-4.5,9-4.5,9l-4.5-6.3c-4.5-5.4-8.1-27.8-5.4-32.3L575.9,95.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M667.5,126.7l-51.2,0.9v-8.1l50.3-4.5L667.5,126.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M706.1,128.5l-55.7,0.9l-0.9-15.3l55.7-4.5L706.1,128.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M743.8,129.4h-47.6l-0.9-19.8l46.7-4.5L743.8,129.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M743.8,133h0.9l0.9-0.9l0.9-0.9v-0.9l-0.9-26l-0.9-1.8l-1.8-0.9l-1.8,0.9l-0.9,1.8l0.9,26l0.9,0.9v0.9 l0.9,0.9H743.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M616.3,129.4l-1.8-0.9l-0.9-1.8v-7.2l0.9-0.9v-0.9h1.8l0.9,0.9h0.9v9.9l-0.9,0.9H616.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M516.7,323.3c3.6-13.5,12.6-38.6,9.9-93.4v-14.4c11.7-1.8,28.7,11.7,28.7,11.7S544.5,297.3,516.7,323.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M567.9,163.5c0,0-28.7,5.4-44,25.1c-15.3,19.8-39.5,47.6-44.9,57.5c-5.4,9.9-21.5,76.3-21.5,76.3 s0.9,1.8,5.4,2.7h7.2c0,0,21.5-38.6,28.7-58.4c3.6-8.1,61.1-39.5,82.6-36.8C589.4,231.8,567.9,163.5,567.9,163.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M667.5,112.4c0,0,5.4,4.5,9.9,2.7c3.6-1.8,2.7-3.6,2.7-3.6S669.3,108.8,667.5,112.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M596.6,185.1c0,0-12.6,86.2-103.2,111.3l-9.9,20.6l17.1,2.7c0,0,103.2-31.4,101.5-136.5L596.6,185.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M594.8,171.6l-4.5,0.9v6.3l6.3,6.3l5.4-0.9v-9l-3.6-3.6H594.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M577.7,154.6c0,0-3.6,0.9-12.6,9c0,0,9,20.6,27.8,23.3c0,0,0-9.9,1.8-15.3 C594.8,171.6,579.5,165.3,577.7,154.6z M594.8,171.6c0,0,9,5.4,9.9,13.5c0,0,3.6-5.4,2.7-9.9c-0.9-4.5-4.5-9-4.5-9 S602.9,170.7,594.8,171.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsCompany);
export default __webpack_public_path__ + "static/media/as_company.61c39253c726b3ffd311127aed7b961b.svg";
export { ForwardRef as ReactComponent };